class PopUp {
  stateClasses = {
    show: 'popup--show',
  }
  constructor($el) {
    this.$el = $el;
    this.$close = $el.find('[data-popup="close"]');
    this.$links = $el.find('.rich-text a');

    console.log(this.$links);

    this.init();
  }

  init = () => {
    this.$close.on('click', this.hide);
    this.$links.on('click', this.hide);
  }

  show = () => {
    this.$el.addClass(this.stateClasses.show);
  }
  
  hide = () => {
    this.$el.removeClass(this.stateClasses.show);
    sessionStorage.setItem('popup', 'shown');
  }
}

export default PopUp;